import React from 'react';
interface CardProps {
  children: ReactNode;
  className?: string;
  variant?: 'white' | 'soft';
}
export function Card({
  children,
  className = '',
  variant = 'white'
}: CardProps) {
  const baseStyles = 'rounded-2xl p-6 md:p-8 transition-shadow duration-300';
  const variants = {
    white: 'bg-white shadow-sm border border-slate-100',
    soft: 'bg-slate-50/80 border border-slate-100'
  };
  return <div className={`${baseStyles} ${variants[variant]} ${className}`} data-id="element-2">
      {children}
    </div>;
}